import axios from "axios";
import * as types from '../constants/ActionTypes';
import { toast } from 'react-toastify';


// Url's
const tenantUrl = `${process.env.REACT_APP_API_URL}mobileshop/tenant-authenticate`;
const csatenantUrl = `${process.env.REACT_APP_API_URL}mobileshop/csa-authenticate`;
const mainPageUrl = `${process.env.REACT_APP_API_URL}mobileshop/main-page`
const getTokenUrl = `${process.env.REACT_APP_API_URL}get-token`



// Actions
const tenantSuccess = data => ({
  type: types.TENANT_SUCCESS,
  data
});

const tenantRequested = () => ({
  type: types.TENANT_REQUEST
});

const tenantFailure = error => ({
  type: types.TENANT_FAILURE,
  error
});

const getTokenSuccess = data => ({
  type: types.GETTOKEN_SUCCESS,
  data
});

const getTokenRequested = () => ({
  type: types.GETTOKEN_REQUEST
});

const getTokenFailure = error => ({
  type: types.GETTOKEN_FAILURE,
  error
});

const csaUserAuthInfo = () => ({
  type: types.CSA_USER_AUTH,
})

const auth = {
  "tenant_user_id": process.env.REACT_APP_TENANT_USER_ID,
  "tenant_password": process.env.REACT_APP_TENAND_USER_PASSWORD
}

const csaAuth = {
  "csa_user_id": process.env.REACT_APP_TENANT_USER_ID,
  "csa_password": process.env.REACT_APP_TENAND_USER_PASSWORD
}

// API
export const getTenant = (url) => {
  return dispatch => {
    dispatch(tenantRequested());
    axios.post(tenantUrl,
      auth, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        //'Content-Type': 'application/json; charset=UTF-8'
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(tenantSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(tenantFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

 export const getCSATenant = (url) => {
   return dispatch => {
     dispatch(tenantRequested());
     axios.get(mainPageUrl,
      {
     params :  {
       
     }
   })
       .then(res => {
         if (res.data.ack === "Success") {
           dispatch(tenantSuccess(res.data.results));
         } else if (res.data.ack === "Failure") {
           dispatch(tenantFailure(res.data.status));
         }
       })
       .catch(err => {
         throw err;
         // dispatch(addTodoFailure(err.message));
       });
   };
 };

export const getCSATenantDetails = (csaAuthDetails) => {
  return dispatch => {
    dispatch(tenantRequested());
    // axios.post(csatenantUrl,
    //   csaAuth, {
    //   headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    //     //'Content-Type': 'application/json; charset=UTF-8'
    //   },
    // })
    axios.get(csatenantUrl,
      {
        params :  {
          csa_user_id  : csaAuth.csa_user_id && csaAuth.csa_user_id,
          csa_password : csaAuth.csa_password && csaAuth.csa_password,
          language_code : csaAuth.language_code && csaAuth.language_code
        }

   })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(tenantSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(tenantFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};
export const getToken = (connection_id,username) => {
  return dispatch => {
    dispatch(getTokenRequested());
    
    axios.get(getTokenUrl,{
         params :  {
           connection_id  : connection_id,
           username : username
          
         }

   }
      )
      .then(res => {
        if (res.data) {
          

          dispatch(getTokenSuccess(res.data));
        } else if (res.data.ack === "Failure") {
          dispatch(getTokenFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

export const getCSATenant1 = (csaUserAuth) => {
  return dispatch => {
    dispatch(tenantRequested());
    // axios.post(csatenantUrl,csaUserAuth
    //   ,{
    //     headers: {
    //       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    //       //'Content-Type': 'application/json; charset=UTF-8'
    //     },
    //   })
    axios.get(csatenantUrl,
      {
        params :  {
          csa_user_id  : csaUserAuth.csa_user_id && csaUserAuth.csa_user_id,
          csa_password : csaUserAuth.csa_password && csaUserAuth.csa_password,
          language_code : csaUserAuth.language_code && csaUserAuth.language_code
        }

   })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(tenantSuccess(res.data.results));
          dispatch(csaUserAuthInfo());
         // toast.success("Logged in");
        } else if (res.data.ack === "Failure") {
          localStorage.removeItem('csa_user_id')
          localStorage.removeItem('csa_password')          
          toast.error(`${res.data.status.message ? res.data.status.message : 'Login failed. Mobile Number or Password might be incorrect. Try again.'}`);
          dispatch(tenantFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};
export const getCsaUserInfo = (csaUserAuth) => {
  return async dispatch => {
try {
    dispatch(tenantRequested());
    const response = await 
    //  axios.post(csatenantUrl,
    //   csaUserAuth, {
    //   headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    //     //'Content-Type': 'application/json; charset=UTF-8'
    //   },
    // })
    axios.get(csatenantUrl,
      {
        params :  {
          csa_user_id  : csaUserAuth.csa_user_id && csaUserAuth.csa_user_id,
          csa_password : csaUserAuth.csa_password && csaUserAuth.csa_password,
          language_code : csaUserAuth.language_code && csaUserAuth.language_code
        }

   })
    
    .then(res=>res.data);

        if (response.ack === "Success") {
          if(response.results.tenant_details.easy_rewards_flg === 'Y') {
          dispatch(getToken(response.results.connection_id,csaUserAuth.csa_user_id && csaUserAuth.csa_user_id));
          }
          dispatch(tenantSuccess(response.results));
          dispatch(csaUserAuthInfo());
          return response.results;
         // toast.success("Logged in");
        } 
        else if (response.ack === "Failure") {
          localStorage.removeItem('csa_user_id')
          localStorage.removeItem('csa_password')          
          toast.error(`${response.status.message ? response.status.message : 'Login failed. Mobile Number or Password might be incorrect. Try again.'}`);
          dispatch(tenantFailure(response.status));
          return "failure";
        }
      }
      catch(err) {
        throw err;
        // dispatch(addTodoFailure(err.message));
      }
  };
};

